<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "BreadCrumbEvent" ,
    components: {
        AjaxLoad,
    },
    data() {
        return {
            event: null,
        }
    },
    computed: {
        breadcrumb() {
            return {
                text: this.event?.NAME,
            };
        }
    },
    beforeDestroy() {
        this.$store.commit('UPDATE_BREAD_CRUMBS', {event: null});
    },
}
</script>

<template>
    <ajax-load
        v-model="event"
        :url="$apiUrl.getForumEventUrl($route.params)"
        :transform="response => response.data.data.items[0]"
        @input="$store.commit('UPDATE_BREAD_CRUMBS', {event: $event})"
    >
        <router-view></router-view>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
